import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import menu from '../assets/icons/menu.svg';
import arrow from '../assets/icons/arrow.svg';
import { useLocation } from "react-router-dom";

const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth;
};

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState<boolean>(false);
  const [navbarBg, setNavbarBg] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === "/";
  const windowWidth = useWindowWidth();

  const toggleDropdown = () => {
    setOpenDropdown(!openDropdown);
  };

  const handleLinkClick = () => {
    setMenuOpen(false);
    setOpenDropdown(false);
  };

  const handleLinkClick1 = () => {
    openDropdown ? setOpenDropdown(false) : setOpenDropdown(true);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setNavbarBg(true);
      } else {
        setNavbarBg(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className={`z-50 fixed flex items-center px-[48px] w-full ${isHomePage ? '' : '!text-[#8f9537] bg-white '} ${navbarBg ? 'bg-white shadow-2xl' : 'text-[#8f9537] lg:text-white'}`}>
      <div className='py-8 w-[60%] 2xl:w-[40%]'>
        <Link to="/"><img src={require('../assets/imgs/logo.png')} className='h-[40px]' /></Link>
      </div>
      <div className={`flex xl:flex-row text-[16px] font-[Roboto] justify-end font-medium 2xl:w-[60%] transition-all duration-500 ease-in-out
    ${menuOpen ? 
          "absolute opacity-100 flex-col gap-2 top-[88px] bg-white w-full left-0 py-2 max-h-[1000px] overflow-hidden"
          :
          "absolute opacity-0 xl:opacity-100 xl:relative flex-col gap-1 top-[-88px] w-full left-0 pl-[50px] max-h-0 xl:max-h-full xl:top-0"}`}>

        <Link to="/" className='px-10 py-3 lg:py-8' onClick={handleLinkClick}>Home</Link>
        <div
          onMouseEnter={() => setOpenDropdown(true)}
          onMouseLeave={() => setOpenDropdown(false)}
          onClick={() => handleLinkClick1()}
          className='relative px-10 py-3 lg:py-8'>
          <p className='flex'>Category  <img src={arrow} alt='arrow icon' className={`transition-all duration-500 ease-in-out ${!openDropdown ? 'rotate-90' : '-rotate-90'}`} /></p>
          <div className={`bg-white shadow-lg lg:absolute left-0 top-[95px] overflow-auto w-max transition-all duration-500 ease-in-out flex flex-col text-[#8f9537] opacity-0 ${openDropdown ? 'opacity-100 pointer-events-auto h-[31.5vh] lg:h-auto' : 'opacity-0 pointer-events-none h-0 -z-20'}`} style={{ maxHeight: '50vh', overflowY: 'auto' }}>
            <Link to="/properties/Property" className='hover:bg-[#50505018] px-5 py-5' onClick={handleLinkClick}>Buy property</Link>
            <Link to="/properties/Land" className='hover:bg-[#50505018] px-5 py-5' onClick={handleLinkClick}>Buy land</Link>
            <Link to="/properties/Rental" className='hover:bg-[#50505018] px-5 py-5' onClick={handleLinkClick}>Rentals</Link>
            <Link to="/properties/Shortlets" className='hover:bg-[#50505018] px-5 py-5' onClick={handleLinkClick}>Shortlets</Link>
            <Link to="/Agricultural Investment" className='hover:bg-[#50505018] px-5 py-5' onClick={handleLinkClick}>Agricultural Service</Link>
            <Link to="/Logistics" className='hover:bg-[#50505018] px-5 py-5' onClick={handleLinkClick}>Logistics Service</Link>
            <Link to="/OilandGAs" className='hover:bg-[#50505018] px-5 py-5' onClick={handleLinkClick}>Oil & Gas Service</Link>
            <Link to="/properties/Sold Properties" className='hover:bg-[#50505018] px-5 py-5' onClick={handleLinkClick}>Sold properties</Link>
            <Link to="/#testimonial" className='hover:bg-[#50505018] px-5 py-5' onClick={handleLinkClick}>Testimonial</Link>
          </div>
        </div>

        <Link to="/About" className='px-10 py-3 lg:py-8' onClick={handleLinkClick}>About</Link>
        <Link to="/Contact" className='px-10 py-3 lg:py-8' onClick={handleLinkClick}>Contact</Link>
      </div>
      <div className='xl:hidden ml-auto'>
        <img src={menu} onClick={() => setMenuOpen(!menuOpen)} alt='menu icon' />
      </div>
    </div>
  );
};

export default Navbar;
